// ─── Shared utilities ────────────────────────────────────────────

function parseDate(dateStr) {
    if (dateStr.includes('-')) {
        const [year, month, day] = dateStr.split('-');
        return new Date(year, month - 1, day);
    } else {
        const [day, month, year] = dateStr.split('/');
        return new Date(year, month - 1, day);
    }
}

/* isClosedDay lives in assets/charged-nights.js — loaded first in theme.liquid.

   This file used to declare its own. A top-level `function isClosedDay` creates a global,
   so whichever script executed last silently won, and the two disagreed about how to read
   a Date: this copy used local parts, the shared one used UTC parts. Whenever the shared
   one won, every grid cell was tested as the PREVIOUS day — Sunday closures greyed the
   Monday, and Labour Day greyed the day after it.

   The shared version now normalises its input (see civil() there) so a local-midnight
   Date and a 'YYYY-MM-DD' string mean the same day. Do not re-add a local copy: two
   declarations of the same global is the bug, not the mismatch. */

/*  Delegates to charged-nights.js, which owns the one month list. This used to call
    toLocaleDateString('en-AU', …), whose Intl data abbreviates September as "Sept"
    while three other files hard-coded "Sep" — see the note there. Still exposed as
    window.formatDate, because pp-product.js calls it in five places. */
function formatDate(dateStr) {
    return window.formatBookingDate ? window.formatBookingDate(dateStr) : '';
}

function formatFullDate(date) {
    return date.toLocaleDateString('en-AU', {
        weekday: 'short',
        day:     'numeric',
        month:   'short'
    }).replace(',', '');
}

/*  ── ONE READER FOR "WHAT IS BLOCKED AT THE BRANCH PICKED IN THE BAR" — dev-build 192
    Every blackout reader in this file used to be gated on activeLocationMatchesCart():
    if the bar's branch was not the cart's saved branch, it returned "nothing blocked",
    because the only ranges on the page were the saved branch's. Switch Melbourne to
    Sydney in the bar and every red day vanished until "Use these dates" was pressed.

    booking-bar.liquid now publishes availability_by_location for every branch. This
    returns the cart items with `availability` swapped for the picked branch's, so the
    readers below need no location logic of their own. A branch with no entry (an old
    cached page) falls back to the saved-branch data only when it IS the saved branch —
    never shows one branch's dates on another.                                        */
function bbItemsForActiveLocation() {
    const activeLocation = $('.bb-panel-location.active').data('location');
    const name  = (window.locationMetaobjects?.[activeLocation]?.name || '').toLowerCase();
    const items = window.bookingBarItemData?.items || [];
    if (!name) return [];
    return items.map(item => {
        const byLoc = item.availability_by_location && item.availability_by_location[name];
        if (byLoc) return { ...item, availability: { ...(item.availability || {}), ...byLoc } };
        return activeLocationMatchesCart(activeLocation) ? item : { ...item, availability: { blocked_ranges: '', blocked_add_ons: '', product_messages: '' } };
    });
}

/*  ── RED DAYS, OPTION A — dev-build 193 ──────────────────────────────────────────
    One rule, blackout-cascade.js, decides whether a hire hits a blackout. The bar used
    its own copy (blocked_ranges, painted by calendar DAY), which knew nothing of the
    two "Also block…" switches and painted the first blackout day red even though
    returning that morning is allowed.

    A day is red when choosing it would make a booking the rule refuses:
      choosing a start   (no start yet, or both set)  → the hire D → D+1
      choosing a return  (start S set, D after S)     → the hire S → D
    so a return day past a blackout is red too: it would cross it. A red day is never
    selected. Clicking it shows why, naming only the gear that is out.

    Copy is extracted from Booking Panel Layout.dc.html, never re-typed.            */
var BB_RED_COPY = {
    "greyNoReturn": "{who} {is} booked out from {first}, remove the {itemORpackageORitemsORpacks} or choose other dates",
    "greyCross": "{who} {is} booked out from {first}, remove the {itemORpackageORitemsORpacks} or choose other dates",
    "cellTitleRed": "Tap for details",
    "whoAll": "Everything in your booking",
    "whoMany": "{count} items",
    /*  218 — rewritten (Ben: "let's improve this", screenshot 27-09-2026). "The {who}"
        read "The Everything in your booking are…". {who} now carries no article, and
        "Everything in your booking" takes "is". {it} is "it" or "them".
        Provisional wording, for the #207 review. */
    "awayHead": "{who} {is} booked out on {date}",
    "awayFootOpen": "Choose a different start date, or remove {it} from your booking.",
    "awayFootShut": "Choose different dates, or remove {it} from your booking.",
    "pickEdgeHead": "{who} {isnt} back in time for a pick-up on {date}",
    "pickEdgeFoot": "Choose a later start date, or remove {it} from your booking.",
    "crossHead": "{who} {is} booked out on {date}",
    "crossFoot": "Choose different dates, or remove {it} from your booking.",
    "retEdgeHead": "{who} {is} booked out on {date}",
    "retEdgeFoot": "Choose different dates, or remove {it} from your booking."
};

function bbDayShift(iso, n) {
    const p = String(iso).split('-');
    return new Date(Date.UTC(+p[0], +p[1] - 1, +p[2] + n)).toISOString().slice(0, 10);
}

function bbActiveLocGid() {
    const h = $('.bb-panel-location.active').data('location');
    const l = window.locationMetaobjects?.[h];
    if (!l || !l.gid) return null;
    return String(l.gid).startsWith('gid://') ? String(l.gid) : 'gid://shopify/Metaobject/' + l.gid;
}

function bbOutLines(s, e, locGid) {
    const B = window.DJWBlackout;
    if (!B) return [];
    const loc = locGid || bbActiveLocGid();
    return (window.bookingBarItemData?.items || []).filter(it => {
        const pg = it.product_id ? 'gid://shopify/Product/' + it.product_id : null;
        const vg = it.variant_id ? 'gid://shopify/ProductVariant/' + it.variant_id : null;
        return (pg && B.productBlocked(pg, s, e, loc)) ||
               (vg && B.variantBlocked(vg, s, e, loc)) ||
               (pg && Array.isArray(it.options) && B.configurationBlocked(pg, it.options, s, e, loc));
    });
}

/*  ── RED OR GREY — dev-build 198 (Ben, 26-09-2026) ───────────────────────────────
    Red is only for days the gear is actually away, or that a blackout switch
    blocks. A day that is unpickable for any other reason — a start with no return
    that works, a return that would run through a blackout — is GREY and still
    explains itself when clicked. 193 painted all of these red, so red moved around
    as the customer clicked and showed on days nothing was blacked out.

      choosing a start  (no start, or both set)
        red   'away'      a blacked-out night is D itself
        red   'pickEdge'  D is the morning after the last night, pick-up switch on
        grey  'noReturn'  D is fine but the earliest return (D+1) is the first
                          morning with the return switch on — nothing works
      choosing a return (start S, D after S)
        red   'cross'     the gear is away on the morning of D (first < D <= last)
        red   'retEdge'   D is the first morning, return switch on
        grey  'runsThru'  anything else refused — the hire would cross a blackout  */
function bbRedBlock(d) {
    const st = window.bookingDates || {};
    const returnPhase = !!(st.start && !st.end && d > st.start);
    const s = returnPhase ? st.start : d;
    const e = returnPhase ? d : bbDayShift(d, 1);
    const lines = bbOutLines(s, e);
    if (!lines.length) return null;
    const loc = bbActiveLocGid();
    const recs = (window.csOverrides || []).filter(r =>
        r && r.effect === 'block' && window.DJWBlackout.locationApplies(r, loc) &&
        window.DJWBlackout.hireHitsRecord(s, e, r));
    let kind, tone;
    if (!returnPhase) {
        if (recs.some(r => d >= r.first_night && d <= r.last_night))            { kind = 'away';     tone = 'red'; }
        else if (recs.some(r => r.block_pickup_on_end_day === true && d === bbDayShift(r.last_night, 1))) { kind = 'pickEdge'; tone = 'red'; }
        else                                                                    { kind = 'noReturn'; tone = 'grey'; }
    } else {
        if (recs.some(r => d > r.first_night && d <= r.last_night))             { kind = 'cross';    tone = 'red'; }
        else if (recs.some(r => r.block_return_on_start_day === true && d === r.first_night)) { kind = 'retEdge'; tone = 'red'; }
        else                                                                    { kind = 'runsThru'; tone = 'grey'; }
    }
    const firsts = recs.map(r => r.first_night).filter(Boolean).sort();
    return {
        kind, tone,
        lines:    lines.length,
        packages: lines.filter(l => l.is_package === true).length,
        names:    [...new Set(lines.map(l => l.title))],
        first:    firsts[0] || '',
        recs:     recs
    };
}

/*  ── TIMED EDGE DAYS — dev-build 200 ─────────────────────────────────────────────
    item_blackout.return_by_time / pickup_from_time (FIELD-TRUTH, decided 25-09-2026).
    Each applies only while its matching block_* switch is OFF:
      return_by_time   the first morning (first_night) — bring it back by then
      pickup_from_time the morning after the last night — collect from then
    and only when the record touches gear in this booking at this branch. Blank means
    the branch's own hours, so no label and no note.
    Several records on one day: the earliest return-by and the latest pick-up-from.
    Copy from Booking Panel Layout.dc.html (markPick, markRet, tPick*, tRet*).    */
var BB_TIME_COPY = {
    "markPick": "from {time}",
    "markRet": "by {time}",
    "tPickLead": "Pick up from {time}",
    "tPickBody": "on {date} – we’ll be waiting for the gear to return from another booking.",
    "tRetLead": "Back by {time}",
    "tRetBody": "on {date} – it’s heading straight back out for another booking."
};

function bbTimeMinutes(t) {
    const m = String(t || '').trim().toLowerCase().match(/^(\d{1,2})(?::(\d{2}))?\s*(am|pm)$/);
    if (!m) return null;
    let h = +m[1] % 12;
    if (m[3] === 'pm') h += 12;
    return h * 60 + (+m[2] || 0);
}

function bbRecordTouchesBooking(r, locGid) {
    /*  Reuses the whole rule (products, variants, add-on mappings) for ONE record,
        with its switches off, over its own first night. Synchronous, and restored in
        finally, so nothing else ever sees the swap. */
    const saved = window.csOverrides;
    window.csOverrides = [Object.assign({}, r, { block_return_on_start_day: false, block_pickup_on_end_day: false })];
    try { return bbOutLines(r.first_night, bbDayShift(r.first_night, 1), locGid).length > 0; }
    finally { window.csOverrides = saved; }
}

/*  dev-build 201 — locGid is optional. The cart page and the attribute builder pass
    the booking's own branch; the calendar uses the one picked in the bar.         */
function bbEdgeTime(d, which, locGid) {
    if (!window.DJWBlackout) return '';
    const loc = locGid || bbActiveLocGid();
    let best = null, label = '';
    (window.csOverrides || []).forEach(r => {
        if (!r || r.effect !== 'block' || !window.DJWBlackout.locationApplies(r, loc)) return;
        const isRet  = which === 'return' && d === r.first_night && r.block_return_on_start_day !== true && r.return_by_time;
        const isPick = which === 'pickup' && d === bbDayShift(r.last_night, 1) && r.block_pickup_on_end_day !== true && r.pickup_from_time;
        if (!isRet && !isPick) return;
        const t = isRet ? r.return_by_time : r.pickup_from_time;
        const mins = bbTimeMinutes(t);
        if (mins === null || !bbRecordTouchesBooking(r, loc)) return;
        if (best === null || (isRet ? mins < best : mins > best)) { best = mins; label = t; }
    });
    return label;
}
window.bbEdgeTime = bbEdgeTime;

function bbRenderTimeNotes() {
    const box = document.querySelector('.bb-time-notes');
    if (!box) return;
    const st = window.bookingDates || {};
    const esc = t => String(t).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const C = BB_TIME_COPY, notes = [];
    const pT = st.start ? bbEdgeTime(st.start, 'pickup') : '';
    const rT = st.end   ? bbEdgeTime(st.end, 'return')   : '';
    const dateOf = d => formatFullDate(new Date(d + 'T00:00:00'));
    if (pT) notes.push([C.tPickLead.replace('{time}', pT), C.tPickBody.replace('{date}', dateOf(st.start))]);
    if (rT) notes.push([C.tRetLead.replace('{time}', rT),  C.tRetBody.replace('{date}', dateOf(st.end))]);
    box.innerHTML = notes.map(n => '<span class="bb-time-note"><strong>' + esc(n[0]) + '</strong> <span>' + esc(n[1]) + '</span></span>').join('');
    box.classList.toggle('hidden', notes.length === 0);
}
window.bbRenderTimeNotes = bbRenderTimeNotes;

/*  ── BOOKED-OUT GEAR ONLY — dev-build 205 (approved layout 2b, part 1) ─────────
    Replaces "Your booking on these dates", which listed every line (Ben: the other
    surfaces already list the booking) and read "0 items" whenever it was printed
    before the gear was added. The bar now names gear ONLY when the dates chosen hit
    a blackout — which, with red days unselectable, happens when the dates were set
    first and the branch, the gear or a blackout changed after.
    Two rows, then fold; two or more out, one "Remove all". No quantities (Ben).
    Copy from Booking Panel Layout.dc.html.                                        */
var BB_OUT_COPY = {
    "itemName": "{item}",
    "rowAway": "Booked out {nights}",
    "nightsOne": "the night of {first}",
    "nightsMany": "{first} – {last}",
    "removeBtn": "Remove",
    "removeAll": "Remove all",
    "showMore": "Show {n} more",
    "showFewer": "Show fewer",
    "stBadOne": "{count} is booked out for these dates",
    "stBadMany": "{count} items are booked out for these dates",
    "stBadBody": "Swap the items or choose new dates"
};
var bbOutOpen = false, bbOutBusy = false;

function bbLineHitBy(line, r, s, e, loc) {
    const saved = window.csOverrides;
    window.csOverrides = [r];
    try { return bbOutLines(s, e, loc).some(l => l.id === line.id && l.key === line.key); }
    finally { window.csOverrides = saved; }
}

/*  ── ONE BOOKED-OUT LIST, TWO PLACES — dev-build 219 ───────────────────────────
    The same list (heading, a row per item with when it's out, Remove, fold after
    two, Remove all) is drawn for the chosen dates (in the footer) and for a clicked
    red day (under the calendar, replacing 218's tag note — Ben, 27-09-2026).
    bbOutListHtml builds it for any hire; the two callers pass the hire and heading.
    data-keys on Remove all carries its own lines, so it removes the right set in
    either place.                                                                  */
var bbRedNoteDay = null, bbRedNoteOpen = false;
function bbOutListHtml(s, e, head, body, open) {
    const lines = (s && e) ? bbOutLines(s, e) : [];
    if (!lines.length) return '';
    const C = BB_OUT_COPY, loc = bbActiveLocGid();
    const esc = t => String(t).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const day = d => formatFullDate(new Date(d + 'T00:00:00'));
    const recs = (window.csOverrides || []).filter(r => r && r.effect === 'block' &&
        window.DJWBlackout.locationApplies(r, loc) && window.DJWBlackout.hireHitsRecord(s, e, r));
    const rows = lines.map(l => {
        const r = recs.find(x => bbLineHitBy(l, x, s, e, loc));
        const nights = !r ? '' : (r.first_night === r.last_night
            ? C.nightsOne.replace('{first}', day(r.first_night))
            : C.nightsMany.replace('{first}', day(r.first_night)).replace('{last}', day(r.last_night)));
        return { key: l.key || String(l.id), name: C.itemName.replace('{item}', l.title).replace(/\s*\{qty\}/, ''), when: nights ? C.rowAway.replace('{nights}', nights) : '' };
    });
    const CAP = 2, extra = rows.length - CAP;
    const shown = open || extra <= 0 ? rows : rows.slice(0, CAP);
    const title = head || (rows.length === 1 ? C.stBadOne.replace('{count}', '1 item') : C.stBadMany.replace('{count}', rows.length));
    let html = '<div class="bb-out-status"><strong>' + esc(title) + '</strong><span>' + esc(body != null ? body : C.stBadBody) + '</span></div>' +
        '<div class="bb-out-rows">' + shown.map(r =>
            '<div class="bb-out-row"><span class="bb-out-row-text"><span class="bb-out-row-name">' + esc(r.name) + '</span>' +
            (r.when ? '<span class="bb-out-row-when">' + esc(r.when) + '</span>' : '') + '</span>' +
            '<button type="button" class="bb-out-remove" data-key="' + esc(r.key) + '">' + esc(C.removeBtn) + '</button></div>').join('');
    if (extra > 0 || rows.length > 1) {
        html += '<div class="bb-out-foot">' +
            (extra > 0 ? '<button type="button" class="bb-out-more">' + esc(open ? C.showFewer : C.showMore.replace('{n}', extra)) + '</button>' : '<span></span>') +
            (rows.length > 1 ? '<button type="button" class="bb-out-all" data-keys="' + esc(rows.map(r => r.key).join('|')) + '">' + esc(C.removeAll.replace('{n}', rows.length)) + '</button>' : '') +
            '</div>';
    }
    return html + '</div>';
}

function bbRenderOutList() {
    const box = document.querySelector('.bb-out-list');
    if (!box) return;
    const st = window.bookingDates || {};
    const html = bbOutListHtml(st.start, st.end, null, null, bbOutOpen);
    /*  A red-day note on screen follows the cart too (after a Remove). */
    if (bbRedNoteDay && $('.bb-panel-content-cap-note.bb-note-red:not(.hidden)').length) bbShowRedNote(bbRedNoteDay, true);
    if (!html) { box.innerHTML = ''; box.classList.add('hidden'); bbOutOpen = false; bbRenderPanelState(); return; }
    box.innerHTML = html;
    box.classList.remove('hidden');
    box.classList.toggle('is-updating', bbOutBusy || window.pbCartBusy === true);   // 207: also while the cart re-prices
    bbRenderPanelState();
}
window.bbRenderOutList = bbRenderOutList;

/*  ── THE PANEL AROUND THE CALENDAR — dev-build 212 (approved layout 2b) ─────────
    One writer for everything in the panel that follows the booking: the branch
    summary line, the Start and Return boxes, the heading over the calendar, the
    footer's status line and the "Use these dates" button. Called at the end of
    updateCalendarSelection() and bbRenderOutList(), which between them run on every
    render, every day click, every restore and every cart change.

    It reads the shared sources — window.bookingDates, the active branch's record in
    window.locationMetaobjects, bbOutLines, bbEdgeTime, computeNights — never another
    element's text.

    The button: blue and live only with a branch, a complete pair and nothing booked
    out. With gear booked out it keeps its label and goes grey, and the footer turns
    red with the count (2b). That replaces the separate "Remove the N items above…"
    line (209); the list it pointed at is directly above the status now.

    Copy is extracted from Booking Panel Layout.dc.html, never re-typed.          */
var BB_PANEL_COPY = {
    "locFirst": "Choose a location for availability and pricing.",
    "stepEmpty": "Choose",
    "window": "{from}–{to}",
    "phasePick": "Choose your start date",
    "phaseRet": "Choose your return date",
    "phaseDone": "Your dates",
    "stPickTitle": "Choose your start date",
    "stPickFoot": "Live availability for everything in your booking.",
    "stRetTitle": "Now choose your return date",
    "stRetFoot": "Starting {pickup}.",
    "stOkTitle": "All good to go!",
    "stOkBody": "{charged} · {branch}",
    "charged": "{n} {nights} charged",
    "chargedFree": " · {n} free (we’re closed)",
    "ctaPick": "Pick your dates"
};

function bbRenderPanelState() {
    const root = document.querySelector('.bb-p2b');
    const foot = document.querySelector('.bb-p2b-foot');
    if (!root && !foot) return;
    const C  = BB_PANEL_COPY;
    const st = window.bookingDates || {};
    const handle = $('.bb-panel-location.active').data('location');
    const loc = (handle && window.locationMetaobjects?.[handle]) || null;
    const txt = (el, t) => { if (el && el.textContent !== t) el.textContent = t; };
    const q = sel => (root && root.querySelector(sel)) || (foot && foot.querySelector(sel));

    txt(q('.bb-p2b-chosen-name'), loc ? (loc.name || '') : '');
    txt(q('.bb-p2b-chosen-addr'), loc ? (loc.address || '') : '');

    /*  dev-build 333 — the bar under the header (booking-bar.liquid, .bb-hbar). Written
        here because this is the one place that follows the panel's state live, so the
        bar and the calendar cannot disagree. The location shows the branch NAME
        (Sydney / Melbourne), as the location list below it does. */
    const hb = document.querySelector('.bb-hbar');
    if (hb) {
        const noon = d => (typeof toNoonUTC === 'function' ? toNoonUTC(d) : d + 'T12:00:00Z');
        let dl = hb.getAttribute('data-empty-dates') || '';
        if (st.start && st.end && typeof formatTopBarDates === 'function') dl = formatTopBarDates(new Date(noon(st.start)), new Date(noon(st.end)));
        else if (st.start) dl = formatDate(st.start);
        txt(hb.querySelector('.bb-hbar-loc'), loc ? (loc.name || '') : (hb.getAttribute('data-empty-loc') || ''));
        txt(hb.querySelector('.bb-hbar-dates'), dl);
        hb.querySelector('.bb-hbar-loc') && hb.querySelector('.bb-hbar-loc').classList.toggle('is-empty', !loc);
        hb.querySelector('.bb-hbar-dates') && hb.querySelector('.bb-hbar-dates').classList.toggle('is-empty', !st.start);
    }

    const pT = loc && st.start ? bbEdgeTime(st.start, 'pickup') : '';
    const rT = loc && st.end   ? bbEdgeTime(st.end, 'return')   : '';
    /*  The branch's window for that day, e.g. "8am – 3pm" from hoursFor, shown as
        2b's "{from}–{to}". A timed edge day narrows the end the blackout touches. A
        closed day or a missing record shows nothing rather than a guess.          */
    const win = (d, which, edge) => {
        if (!d || !loc || typeof window.hoursFor !== 'function') return '';
        const p = String(window.hoursFor(d, loc, which) || '').split(/\s*[–-]\s*/);
        if (p.length !== 2 || !p[0] || !p[1]) return '';
        const from = which === 'pickup' && edge ? edge : p[0];
        const to   = which === 'return' && edge ? edge : p[1];
        return C.window.replace('{from}', from).replace('{to}', to);
    };
    const retPhase = !!(st.start && !st.end);
    if (root) root.querySelectorAll('.bb-p2b-step').forEach(btn => {
        const isStart = btn.getAttribute('data-step') === 'start';
        const d = isStart ? st.start : st.end;
        btn.classList.toggle('is-active', isStart ? !st.start : retPhase);
        btn.classList.toggle('is-empty', !d);
        btn.classList.toggle('is-timed', !!(isStart ? pT : rT));
        txt(btn.querySelector('.bb-p2b-step-value'), d ? formatDate(d) : C.stepEmpty);
        txt(btn.querySelector('.bb-p2b-step-window'), isStart ? win(st.start, 'pickup', pT) : win(st.end, 'return', rT));
    });

    txt(q('.bb-p2b-phase'), !st.start ? C.phasePick : !st.end ? C.phaseRet : C.phaseDone);

    const pickup = st.start ? formatDate(st.start) + (pT ? ' ' + BB_TIME_COPY.markPick.replace('{time}', pT) : '') : '';
    const out = (loc && st.start && st.end && typeof bbOutLines === 'function') ? bbOutLines(st.start, st.end) : [];
    let title, body = '', bad = false, ready = false;
    if (!loc)            { title = C.locFirst; }
    else if (!st.start)  { title = C.stPickTitle; body = C.stPickFoot; }
    else if (!st.end)    { title = C.stRetTitle;  body = C.stRetFoot.replace('{pickup}', pickup); }
    else if (out.length) {
        bad = true;
        title = out.length === 1 ? BB_OUT_COPY.stBadOne.replace('{count}', '1 item') : BB_OUT_COPY.stBadMany.replace('{count}', out.length);
        body = BB_OUT_COPY.stBadBody;
    } else {
        const n = typeof window.computeNights === 'function' ? window.computeNights(st.start, st.end, loc) : { nightsCharged: 0, nightsFree: 0 };
        /*  575: actual nights, long form — see djwNightsText in charged-nights.js. */
        let charged = typeof window.djwNightsText === 'function' ? window.djwNightsText(st.start, st.end, loc, 'long') : '';
        title = C.stOkTitle;
        /*  217 — the branch is no longer repeated: it is on the line at the top of the
            panel (1a). stOkBody's {branch} is dropped here; the COPY row is unchanged. */
        body  = charged;
        ready = true;
    }
    if (foot) {
        foot.classList.toggle('is-bad', bad);
        foot.classList.toggle('is-ready', ready);   // 333: green dot on the verdict chip
        txt(foot.querySelector('.bb-p2b-status-title'), title);
        txt(foot.querySelector('.bb-p2b-status-body'), body);
        /*  615: "All good to go! · 2 nights · 1 free" gets the same "?" as everywhere else. */
        const sb = foot.querySelector('.bb-p2b-status-body');
        if (sb && ready && typeof window.djwNightsHTML === 'function') sb.innerHTML = window.djwNightsHTML(st.start, st.end, loc);
        const btn = foot.querySelector('.bb-panel-footer-bottom-btn');
        if (btn) {
            btn.classList.toggle('active', ready);
            btn.setAttribute('aria-disabled', ready ? 'false' : 'true');
            const label = (loc && st.start && st.end) ? (btn.getAttribute('data-label-use') || btn.textContent.trim()) : C.ctaPick;
            txt(btn, label);
        }
    }
}
window.bbRenderPanelState = bbRenderPanelState;

function bbRemoveLines(keys) {
    if (!keys.length || bbOutBusy) return;
    bbOutBusy = true;
    bbRenderOutList();
    const updates = {};
    keys.forEach(k => { updates[k] = 0; });
    /*  One write for one or many. The fetch wrapper in booking-bar.js sees it and
        re-reads the cart, which repaints the calendar and this list. */
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) })
        .then(r => r.json())
        .then(function () {
            if (document.querySelector('.pb-cart') && window.BookingRow && typeof window.BookingRow.refreshSections === 'function') {
                window.BookingRow.refreshSections();
            }
        })
        .catch(function () {})
        .finally(function () { bbOutBusy = false; if (window.bbRefreshItems) window.bbRefreshItems(); else bbRenderOutList(); });
}

$(document).on('click', '.bb-out-remove', function () { bbRemoveLines([String($(this).data('key'))]); });
$(document).on('click', '.bb-out-all', function () {
    bbRemoveLines(String($(this).attr('data-keys') || '').split('|').filter(Boolean));
});
$(document).on('click', '.bb-out-more', function () {
    if ($(this).closest('.bb-panel-content-cap-note').length) { bbRedNoteOpen = !bbRedNoteOpen; bbShowRedNote(bbRedNoteDay, true); return; }
    bbOutOpen = !bbOutOpen; bbRenderOutList();
});

function bbShowRedNote(d, keepOpen) {
    if (!keepOpen) bbRedNoteOpen = false;
    const b = bbRedBlock(d);
    if (!b) {
        /*  219 — after a Remove the day may no longer be red; the note goes with it. */
        if (bbRedNoteDay === d) { bbRedNoteDay = null; $('.bb-panel-content-cap-note.bb-note-red').removeClass('bb-note-red').addClass('hidden').empty(); }
        return;
    }
    const C = BB_RED_COPY;
    const total = (window.bookingBarItemData?.items || []).length;
    const one = b.names.length === 1, all = b.lines === total;
    const plural = !one && !all;   // 218: "Everything in your booking is…"
    const v = {
        date: formatFullDate(new Date(d + 'T00:00:00')),
        /*  218 — a one-item booking names the item; "Everything in your booking" is
            only for two or more. */
        who:  one ? b.names[0] : all ? C.whoAll : C.whoMany.replace('{count}', b.names.length),
        is:   plural ? 'are' : 'is',
        isnt: plural ? 'aren\u2019t' : 'isn\u2019t',
        it:   one ? 'it' : 'them'
    };
    const fill = t => String(t || '').replace(/\{(\w+)\}/g, (m, k) => v[k] != null ? v[k] : '');
    const esc = t => String(t).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const footOpen = b.recs.some(r => r.first_night === d && r.block_return_on_start_day !== true);
    if (b.tone === 'grey') {
        /*  {itemORpackageORitemsORpacks} — Ben's placeholder, kept by name. One line:
            item or package. Several: packages only if every affected line is one. */
        v.first = b.first ? formatFullDate(new Date(b.first + 'T00:00:00')) : '';
        v.itemORpackageORitemsORpacks = b.names.length === 1
            ? (b.packages > 0 ? 'package' : 'item')
            : (b.packages === b.lines ? 'packages' : 'items');
        const line = fill(b.kind === 'noReturn' ? C.greyNoReturn : C.greyCross);
        (bbRedNoteDay = null, $('.bb-panel-content-cap-note')).removeClass('bb-note-red').html(esc(line)).removeClass('hidden');
        return;
    }
    const keys = {
        away:     ['awayHead', footOpen ? 'awayFootOpen' : 'awayFootShut'],
        pickEdge: ['pickEdgeHead', 'pickEdgeFoot'],
        cross:    ['crossHead', 'crossFoot'],
        retEdge:  ['retEdgeHead', 'retEdgeFoot']
    }[b.kind];
    /*  218 — heading, the gear as a list (when more than one), then what to do.
        Red, because this is a blackout; the other notes in this box stay blue. */
    /*  219 — the booked-out list, for the hire this click would have made: heading
        from the red-day copy (218), then a row per item with Remove. */
    const st0 = window.bookingDates || {};
    const rp = !!(st0.start && !st0.end && d > st0.start);
    const hs = rp ? st0.start : d, he = rp ? d : bbDayShift(d, 1);
    const html = bbOutListHtml(hs, he, fill(C[keys[0]]), fill(C[keys[1]]), bbRedNoteOpen);
    if (!html) return;
    bbRedNoteDay = d;
    $('.bb-panel-content-cap-note').html(html).addClass('bb-note-red').removeClass('hidden');
}

function activeLocationMatchesCart(activeLocation) {
    const activeLocName = (window.locationMetaobjects?.[activeLocation]?.name || '').toLowerCase();
    const cartLocation  = (
        window.pbCartBookings?.location ||
        window.bookingBarItemData?.cartLocation ||
        ''
    ).toLowerCase();
    return cartLocation ? activeLocName === cartLocation : true;
}

/*  ── TURNAROUND IS COUNTED ONCE, IN LIQUID — dev-build 185 ─────────────────────
    availability-resolve.liquid already pads every range: first_night minus
    lead_nights, last_night plus turnaround_nights. The three readers in this file
    then added turnaround_nights AGAIN, so a blackout with 2 turnaround nights held
    the gear 4 nights past the last night on the calendar and 2 everywhere else.
    The padding is the resolver's; the ranges arrive finished and are read as-is.
    availability.turnaround_nights is still published — nothing here reads it. */
function getBookedOutItems(dateString) {
    const allItems = bbItemsForActiveLocation();
    if (!allItems.length) return [];

    return allItems
        .filter(item => {
            const ranges = (item.availability?.blocked_ranges || '')
                .split('§')
                .filter(Boolean)
                .map(r => {
                    const parts = r.split(':');
                    return { from: parts[0], to: parts[1] };
                });
            return ranges.some(range => {
                if (!range.from || !range.to) return false;
                const rangeEnd = new Date(range.to);
                const rangeEndStr = rangeEnd.toISOString().split('T')[0];
                return dateString >= range.from && dateString <= rangeEndStr;
            });
        })
        .map(item => item.title);
}

function buildBookedOutTitle(bookedTitles, totalItems) {
    if (bookedTitles.length === 0) return '';

    const names = bookedTitles.join(', ');

    // All items booked out
    if (bookedTitles.length === totalItems) {
        return `${names} booked out`;
    }

    // Some items booked out
    return `${names} booked out — the rest of your booking is free`;
}

function formatToISO(dateStr) {
    if (!dateStr) return null;
    if (dateStr.includes('-')) return dateStr; // already YYYY-MM-DD
    const [day, month, year] = dateStr.split('/');
    return `${year}-${month}-${day}`;
}

function getBookedOutDateLabel(selectedStart, selectedEnd, itemFrom, itemTo) {
    // Get the overlap between selected range and item's booked range
    const overlapStart = selectedStart > itemFrom ? selectedStart : itemFrom;
    const overlapEnd   = selectedEnd   < itemTo   ? selectedEnd   : itemTo;

    const startDate = new Date(overlapStart);
    const endDate   = new Date(overlapEnd);

    function formatShort(date) {
        return date.toLocaleDateString('en-AU', {
            weekday: 'short',
            day:     'numeric',
            month:   'short'
        }).replace(',', '');
    }

    // Same day overlap
    if (overlapStart === overlapEnd) {
        return `Out ${formatShort(startDate)}`;
    }

    // Range overlap
    return `Out ${formatShort(startDate)} - ${formatShort(endDate)}`;
}

function getItemAvailability(selectedStart, selectedEnd, items) {
    const selFrom = new Date(selectedStart);
    const selTo   = new Date(selectedEnd);

    return items.map(item => {
        const ranges = (item.availability?.blocked_ranges || '')
            .split('§')
            .filter(Boolean)
            .map(r => {
                const parts = r.split(':');
                return { from: parts[0], to: parts[1] };
            });

        if (!ranges.length) {
            return { ...item, status: 'available', outLabel: '' };
        }

        let status   = 'available';
        let outLabel = '';

        for (const range of ranges) {
            if (!range.from || !range.to) continue;
            const rangeStart = new Date(range.from);
            const rangeEnd   = new Date(range.to);
            const hasOverlap = selFrom < rangeEnd && selTo > rangeStart;
            if (hasOverlap) {
                status   = 'booked-out';
                outLabel = getBookedOutDateLabel(selectedStart, selectedEnd, range.from, range.to);
                break;
            }
        }

        return { ...item, status, outLabel };
    });
}

function findFullyBlockedDayInRange(start, end) {
    const locationItems = bbItemsForActiveLocation();

    if (!locationItems.length) return null;

    let current     = new Date(start);
    const endDate   = new Date(end);

    while (current <= endDate) {
        const dateString  = current.toISOString().split('T')[0];
        const bookedTitles = getBookedOutItems(dateString);
        const allBookedOut = bookedTitles.length === locationItems.length;

        if (allBookedOut) return dateString;

        current.setDate(current.getDate() + 1);
    }

    return null;
}

function isDateBlockedByAvailability(dateString) {
    const allItems = bbItemsForActiveLocation();
    if (!allItems.length) return false;

    return allItems.some(item => {
        const ranges = (item.availability?.blocked_ranges || '')
            .split('§')
            .filter(Boolean)
            .map(r => {
                const parts = r.split(':');
                return { from: parts[0], to: parts[1] };
            });
        return ranges.some(range => {
            if (!range.from || !range.to) return false;
            const rangeEnd = new Date(range.to);
            const rangeEndStr = rangeEnd.toISOString().split('T')[0];
            return dateString >= range.from && dateString <= rangeEndStr;
        });
    });
}

// ─── Get available vs closed nights ─────────────────────────────

function getAvailableNights(start, end, locationData) {
    const startDate = parseDate(start);
    const endDate   = parseDate(end);

    let availableNights = 0;
    let closedNights    = 0;
    let current         = new Date(startDate);

    while (current < endDate) {
        if (isClosedDay(current, locationData)) {
            closedNights++;
        } else {
            availableNights++;
        }
        current.setDate(current.getDate() + 1);
    }

    return { availableNights, closedNights };
}

// ─── Build night boxes HTML ──────────────────────────────────────

function buildNightBoxes(start, end, locationData) {
    const startDate = parseDate(start);
    const endDate   = parseDate(end);
    let boxes = '';

    /* The local getHours() that sat here is gone — B19, 11-09-2026. It was one of five
       implementations, and it read `date.getDay()`, the browser's LOCAL weekday, off a
       date built from a UTC-noon timestamp: safe in Australia, wrong in the Americas.
       window.hoursFor also applies Special Trading Date overrides (#64), which no local
       copy did. charged-nights.js loads first and undeferred in theme.liquid, so it is
       always there. */
    const pickupTime = window.hoursFor(startDate, locationData, 'pickup');
    const returnTime = window.hoursFor(endDate,   locationData, 'return');

    // PICK UP
    boxes += `
        <div class="bb-night-box bb-night-box--endpoint">
            <span class="bb-night-box__label">PICK UP</span>
            <strong class="bb-night-box__date">${formatFullDate(startDate)}</strong>
            <span class="bb-night-box__time">${pickupTime}</span>
        </div>
    `;

    // Night boxes
    let current = new Date(startDate);
    while (current < endDate) {
        const closed  = isClosedDay(current, locationData);
        const weekday = current.toLocaleDateString('en-AU', { weekday: 'short' }).replace(',', '');
        const dateNum = current.getDate();
        const mod     = closed ? 'bb-night-box--closed' : 'bb-night-box--charged';
        const status  = closed ? 'not charged' : 'charged';

        boxes += `
            <div class="bb-night-box ${mod}">
                <span class="bb-night-box__weekday">${weekday}</span>
                <strong class="bb-night-box__num">${dateNum}</strong>
                <span class="bb-night-box__status">${status}</span>
            </div>
        `;

        current.setDate(current.getDate() + 1);
    }

    // RETURN
    boxes += `
        <div class="bb-night-box bb-night-box--endpoint">
            <span class="bb-night-box__label">RETURN</span>
            <strong class="bb-night-box__date">${formatFullDate(endDate)}</strong>
            <span class="bb-night-box__time">${returnTime}</span>
        </div>
    `;

    return boxes;
}

// ─── Booking footer ──────────────────────────────────────────────

function bbPanelBookingFooter() {
    const start          = window.bookingDates?.start;
    const end            = window.bookingDates?.end;
    const activeLocation = $('.bb-panel-location.active').data('location');
    const locationData   = window.locationMetaobjects?.[activeLocation];

    if (!start || !end || !locationData) {
        $('.bb-panel-footer-content').empty();
        return;
    }

    $('.bb-panel-footer-content').html(buildNightBoxes(start, end, locationData));
}

/*  ── DO NOT BLANK A BOOKING THE SERVER ALREADY RENDERED ──────────────────────
    booking-bar.liquid now prints the restored location and dates into the markup, so
    there is no blank moment on load. But updateCalendarSelection() runs before
    syncBarFromCart() has hydrated window.bookingDates or applied the .active class to
    the panel's location button — so on that first call `start`, `end` and
    `locationData` are all undefined, it takes the else branch at the bottom, and
    that branch actively writes the empty placeholders over the real values.

    Result was correct → blank → correct, which reads worse than the original flash
    because now there is something real to lose.

    This flag protects only that first pre-hydration call. It is read once at script
    load: if the server rendered a booking, .bb-hire-dates carries .active. The fill
    branch clears it the moment JS has real values.

    A one-shot flag rather than a live state test on purpose. Testing
    "has .active but no window.bookingDates" would also be true when a customer
    deliberately CLEARS their dates — and then the bar would refuse to go back to its
    empty state, which is the same class of bug pointing the other way. */
let bbServerRenderPending = false;

document.addEventListener('DOMContentLoaded', function () {
    bbServerRenderPending = !!document.querySelector('.bb-hire-dates.active');
});

// ─── Calendar selection update ───────────────────────────────────

function updateCalendarSelection() {
    $('.bb-calendar-day').removeClass('selected start-date end-date in-range');

    const start = window.bookingDates.start;
    const end   = window.bookingDates.end;

    const activeLocation = $('.bb-panel-location.active').data('location');
    const locationData   = window.locationMetaobjects?.[activeLocation];
    /* dev-build 233: the suburb, as the desktop bar and the server-rendered phone bar use.
       This read .name, so on phones the bar painted "St Peters" and then flipped to
       "Sydney" once this ran. */
    const locationName = locationData?.suburb || locationData?.name || '';

    const emptyDatesText = window.bookingBarConfig.emptyDatesText;
    const barHelper      = window.bookingBarConfig.barHelper;
    const barCta         = window.bookingBarConfig.barCta;
    const barCtaFilled   = window.bookingBarConfig.barCtaFilled;
    const barEmptyMobile = window.bookingBarConfig.barEmptyMobile;

    if (start && end && locationData) {
        /* Real values in hand — the server-rendered markup has served its purpose. */
        bbServerRenderPending = false;

        /*  dev-build 188 — the last COMPLETE pair, so closing the panel halfway through
            a re-pick can put it back. See bbClosePanel in booking-bar.js. */
        window.bbCommittedDates = { start, end };

        const { availableNights, closedNights } = getAvailableNights(start, end, locationData);
        const totalNights = availableNights + closedNights;
        const formatted   = `${formatDate(start)} - ${formatDate(end)}`;
        const formattedWithLocation = locationName 
            ? `${locationName} · ${formatted}`
            : formatted;

        $('.bb-hire-dates').html(formatted).addClass('active');
        $('.bb-top-mobile-left-subtitle').html(formattedWithLocation); // ✅ with location

        /*  ── ONE WRITER FOR .bb-top-right-title ──────────────────────────────────
            This function used to build its own string for that element:

              "1 night charged · 1 free while we're closed"

            while updateTopBarTitle() in booking-bar.js:145 writes the same element as

              "Fri 11 - Sat 12 Sep · charged as 1 night · you're not charged for Sunday"

            Two writers, two formats, one element — so what the customer saw depended on
            which ran last. On load that was visible as the text changing from the second
            form to the first a moment after the page appeared.

            updateTopBarTitle is the intended one: it names the dates and the reason, and
            it is what the server-rendered markup in booking-bar.liquid reproduces. So
            this function now calls it rather than composing a rival string.

            It also means one fewer night calculation on screen. Note that the
            availableNights/closedNights figures below still come from
            getAvailableNights(), which is NOT the shared computeNights() that
            updateTopBarTitle uses — a separate implementation still feeding the panel
            footer. Left alone here, but it wants folding in.

            Total nights text — panel footer only, unchanged. */
        if (typeof updateTopBarTitle === 'function') {
            updateTopBarTitle(start, end, locationData);
        }

        // Total nights text
        let totalNightsText = typeof window.djwNightsHTML === 'function' ? window.djwNightsHTML(start, end, locationData) : '';   /* 605: with the "?" */

        $('.bb-panel-footer-btn-subtitle').html(totalNightsText);
        $('.bb-top-right-btn').html(barCtaFilled);
        $('.bb-panel-ledger').removeClass('hidden');

        bbPanelBookingFooter();

        /*  dev-build 212 — the every-line breakdown that was updated here is gone, and
            the button and the blocked message are written by bbRenderPanelState(), which
            counts booked-out gear with bbOutLines — the same rule as the list. The count
            this block kept as a fallback (bookedOutCount) went with the breakdown.     */
    } else {
        /* Leave the collapsed bar alone if the server rendered a booking and JS has not
           caught up yet. Everything below this block still runs — those are panel
           internals, and the panel is hidden until opened. */
        if (!bbServerRenderPending) {
            $('.bb-hire-dates').html(emptyDatesText).removeClass('active');
            $('.bb-top-mobile-left-subtitle').html(barEmptyMobile);
            $('.bb-top-right-btn').html(barCta);
        }

        $('.bb-panel-footer-btn-subtitle').empty();
        $('.bb-panel-footer-content').empty();
        $('.bb-panel-ledger').addClass('hidden');

    }

    // ── Highlight selected days ──────────────────────────────
    $('.bb-calendar-day').each(function () {
        const date = $(this).data('date');

        if (date === start)                              $(this).addClass('selected start-date');
        if (date === end)                                $(this).addClass('selected end-date');
        if (start && end && date > start && date < end)  $(this).addClass('in-range');
    });

    bbRenderPanelState();
}

// ─── Calendar render ─────────────────────────────────────────────

document.addEventListener('DOMContentLoaded', function () {
    const today = new Date();
    let calendarOffset   = 0;
    const CALENDAR_HORIZON = window.bookingBarConfig?.bookingCalendarHorizon || 12;

    window.renderCalendar = function () {
        const base      = new Date(today.getFullYear(), today.getMonth() + calendarOffset, 1);
        const nextMonth = new Date(base.getFullYear(), base.getMonth() + 1, 1);

        renderMonth(
            document.querySelector('#month-current'),
            base.getFullYear(),
            base.getMonth()
        );

        renderMonth(
            document.querySelector('#month-next'),
            nextMonth.getFullYear(),
            nextMonth.getMonth()
        );

        updateCalendarNav();
    };

    /*  576: opening the bar shows the month of the chosen start date, or this month
        if no dates are set. Only on open — paging while choosing is left alone. */
    window.bbCalendarToSelection = function () {
        const s = (window.bookingDates || {}).start;
        let off = 0;
        if (s) { const d = new Date(String(s).slice(0, 10) + 'T12:00:00'); if (!isNaN(d)) off = (d.getFullYear() - today.getFullYear()) * 12 + d.getMonth() - today.getMonth(); }
        calendarOffset = Math.max(0, Math.min(off, CALENDAR_HORIZON - 2));
        window.renderCalendar();
    };

    function updateCalendarNav() {
        const prevBtn = document.querySelector('.bb-calendar-prev');
        const nextBtn = document.querySelector('.bb-calendar-next');

        if (prevBtn) {
            prevBtn.disabled = calendarOffset === 0;
            prevBtn.classList.toggle('is-disabled', calendarOffset === 0);
        }
        if (nextBtn) {
            nextBtn.disabled = calendarOffset >= CALENDAR_HORIZON - 2;
            nextBtn.classList.toggle('is-disabled', calendarOffset >= CALENDAR_HORIZON - 2);
        }
    }

    document.addEventListener('click', function (e) {
        if (e.target.closest('.bb-calendar-prev')) {
            if (calendarOffset <= 0) return;
            calendarOffset--;
            window.renderCalendar();
            return;
        }

        if (e.target.closest('.bb-calendar-next')) {
            if (calendarOffset >= CALENDAR_HORIZON - 2) return;
            calendarOffset++;
            window.renderCalendar();
            return;
        }
    });

    function renderMonth(container, year, month) {
        const date      = new Date(year, month, 1);
        /*  dev-build 333: the booking panel shows "November 2026" and "Mon Tue …"
            (approved design). Other calendars keep the short forms. */
        const inPanel   = !!(container && container.closest && container.closest('.bb-panel'));
        const monthName = date.toLocaleString('default', { month: inPanel ? 'long' : 'short', year: 'numeric' });
        const weekdays  = inPanel ? ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'] : ['M','T','W','T','F','S','S'];

        let html = `
            <strong class="bb-month-title">${monthName}</strong>
            <div class="bb-calendar-weekdays">
                ${weekdays.map(day => `<div class="weekday">${day}</div>`).join('')}
            </div>
            <div class="bb-calendar-grid">
        `;

        const firstDay = (date.getDay() + 6) % 7;
        const days     = new Date(year, month + 1, 0).getDate();

        // Empty cells
        for (let i = 0; i < firstDay; i++) {
            html += `<div class="empty"></div>`;
        }

        // ✅ Define locationItems once before the day loop
        const activeLocation  = $('.bb-panel-location.active').data('location');
        const locationItems   = bbItemsForActiveLocation();
        const allItems        = locationItems;

        /*  C21 — one call per render, not one per day cell. Guarded on the function
            existing: charged-nights.js loads undeferred in theme.liquid and this file is
            deferred, so it is always there in practice, but a calendar that silently
            offers today is a better failure than a calendar that throws. */
        const cutOffPassed = typeof window.sameDayCutOffPassed === 'function'
            ? window.sameDayCutOffPassed(window.selectedLocation,
                                         window.bookingBarConfig?.storeTimeZone)
            : false;

        // Day cells
        for (let day = 1; day <= days; day++) {
            const dateString  = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
            const currentDate = new Date(year, month, day);

            let disabled    = true;
            let closed      = false;
            let unavailable = false;
            let bookedOut   = false;
            let allBookedOut = false;
            let boGrey      = false;
            let title       = '';

            /*  ── PAST DATES ARE NEVER SELECTABLE, INCLUDING ON THE CART PAGE ──────
                This used to read

                  (disabled || isPast) && !isCartPage

                on both the class and the disabled attribute — so the cart page was
                exempt from BOTH, and a customer could pick dates that had already
                gone. The tooltip at line ~618 even said "This date has passed" while
                the button stayed clickable.

                The two conditions are not the same kind of thing and should not share
                an exemption:

                  disabled  availability — booked out, blacked out, past the hire cap.
                            The cart page is deliberately permissive about these, the
                            same way it overrides the hire cap to 100. Whether that is
                            right is an open question, but it is a decision someone made
                            and it is left alone here.

                  isPast    the date has gone. No page, no cart, no override makes a
                            past date hireable.

                Now written as (disabled && !isCartPage) || isPast — the cart-page
                exemption applies only to availability, and never to time. */
            const isCartPage = !!document.querySelector('.pb-cart');
            const todayMidnight = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            const isPast        = currentDate < todayMidnight;

            /*  ── C21 / #59: TODAY, AFTER THE CUT-OFF ──────────────────────────────
                Treated exactly like a past date: no cart page, no override, nothing
                makes it selectable. It is the same kind of fact — time has gone — and
                the reason isPast was split out of `disabled` above.

                Kept as its own flag rather than folded into isPast so the tooltip can
                say why. "This date has passed" is wrong and confusing at 3:01pm on the
                day in question; the customer needs the time and the alternative.

                cutOffPassed is computed ONCE per render, above the day loop — it does
                not vary by cell, and storeNow() builds an Intl formatter each call. */
            const isCutOff = cutOffPassed && !isPast &&
                             currentDate.getTime() === todayMidnight.getTime();

            if (window.selectedLocation) {
                disabled = false;

                if (!isPast) {
                    closed = isClosedDay(currentDate, window.selectedLocation);
                    if (closed) {
                        /* ── Get title for closed day ───────────────────────
                           The `oneOff` lookup that led this block is gone (11-09-2026).
                           It found any trading-day record with a matching date and used
                           its title as the closed-day tooltip. A dated trading day is
                           now an HOURS OVERRIDE — the location is open, with different
                           hours — so it is not a closure and must not label one.
                           isClosedDay() lost the matching branch in the same pass, so
                           this block is now only reachable by a holiday or a recurring
                           weekday. Closed dates are Holidays. */
                        const holiday = (window.selectedLocation.holidays || []).find(h =>
                            h.repeats_annually ? h.date.slice(5) === dateString.slice(5) : h.date === dateString
                        );
                        const weekday = currentDate.toLocaleString('en-US', { weekday: 'long' });
                        const recurring = (window.selectedLocation.closures || []).find(c =>
                            !c.date && c.weekday?.toLowerCase() === weekday.toLowerCase() && c.enabled === false
                        );

                        /* Name plus note, joined the way the old dated-closure tooltip was:
                           "Closed — stocktake · Back open 29 Dec". filter(Boolean) keeps it to
                           just the name when there is no note, which is the common case. */
                        title = [holiday?.name, holiday?.note].filter(Boolean).join(' · ')
                            || (recurring ? `Closed ${weekday}` : 'Closed');
                    }

                    
                    /*  ── A CLOSED DAY IS GREY, NEVER RED — dev-build 185 ──────────────
                        Red means "we are open, your gear is not". A day we are shut, or
                        today after the same-day cut-off, is not about the gear at all,
                        and the gear answer must not paint over it. It did: .booked-out
                        comes later in booking-bar.css than .is-disabled at the same
                        specificity, so a cut-off today that was also a blackout day
                        turned red.

                        Fixed here rather than in the stylesheet, because the fact is
                        wrong, not the paint — a CSS reorder would still leave the
                        booked-out class on a day the gear question never applied to.
                        Past dates never reach this block.                             */
                    const shutAnyway = closed || isCutOff;
                    /*  dev-build 199 — a day the customer has already picked is never
                        re-judged. With both dates set the calendar reads every day as a
                        possible NEW start, and 21 Oct as a start has no return that works,
                        so the chosen return turned grey over the blue (Ben, 26-09-2026). */
                    const isPicked = dateString === window.bookingDates.start ||
                                     dateString === window.bookingDates.end;
                    const redBlock = (shutAnyway || isPicked) ? null : bbRedBlock(dateString);
                    bookedOut    = !!redBlock && redBlock.tone === 'red';
                    boGrey       = !!redBlock && redBlock.tone === 'grey';
                    allBookedOut = bookedOut && redBlock.lines === locationItems.length && locationItems.length > 0;

                    if ((bookedOut || boGrey) && !title) title = BB_RED_COPY.cellTitleRed;
                } else {
                    title = window.bookingBarConfig?.bookingPastDateTooltip || 'This date has passed';
                }

                /*  Set after the isPast branch so it wins for today: the two are mutually
                    exclusive by construction, but ordering it this way means a future
                    change to either cannot leave today with the past-date wording. */
                if (isCutOff) {
                    const cutAt = typeof window.cutOffLabel === 'function'
                        ? window.cutOffLabel(window.selectedLocation,
                                             window.bookingBarConfig?.storeTimeZone)
                        : '';
                    const tpl = window.bookingBarConfig?.bookingCutOffTooltip ||
                        "Same-day pick-ups close at {time}. Pick tomorrow, or give us a call.";
                    title = tpl.replace('{time}', cutAt || 'the cut-off');
                }
            } else {
                title = 'Choose a pick-up location first';
            }

            // Check max hire range
            if (window.bookingDates.start && !window.bookingDates.end) {
                const startDate      = new Date(window.bookingDates.start);
                const maxDate        = new Date(startDate);
                const bookingMaxNights = window.bookingBarConfig.bookingMaxNights;
                maxDate.setDate(maxDate.getDate() + bookingMaxNights);

                if (currentDate > maxDate) {
                    if (!closed) { 
                        unavailable = true;
                        /*  Past the longest hire is grey, never red — red is blackouts only
                            (Ben, Blackout Calendar States). */
                        if (bookedOut || boGrey) { bookedOut = false; allBookedOut = false; boGrey = false; title = ''; }
                        if (!title) title = 'Longest hire online is 6 charged nights';
                    }
                }
            }

            /*  dev-build 200 — "from 2pm" / "by 10am" under a timed edge day. Never on a
                day that cannot be picked anyway. */
            let dayMark = '';
            if (!isPast && !closed && !isCutOff && !bookedOut && !boGrey && !unavailable && window.selectedLocation) {
                const st = window.bookingDates;
                const retPhase = st.start && !st.end && dateString > st.start;
                if (dateString === st.end || retPhase) {
                    const t = bbEdgeTime(dateString, 'return');
                    if (t) dayMark = BB_TIME_COPY.markRet.replace('{time}', t);
                } else {
                    const t = bbEdgeTime(dateString, 'pickup');
                    if (t) dayMark = BB_TIME_COPY.markPick.replace('{time}', t);
                }
            }

            html += `
                <button
                    class="bb-calendar-day ${dayMark ? 'has-mark' : ''} 
                        ${(disabled && !isCartPage) || isPast || isCutOff ? 'is-disabled' : ''} 
                        ${closed                     ? 'is-closed'                      : ''} 
                        ${!closed && unavailable     ? 'is-unavailable'                 : ''} 
                        ${bookedOut && allBookedOut  ? 'booked-out booked-out--full'    : ''} 
                        ${bookedOut && !allBookedOut ? 'booked-out' : ''}
                        ${boGrey                     ? 'bo-grey'                        : ''}"
                    data-date="${dateString}"
                    title="${title}"
                    ${(disabled && !isCartPage) || isPast || isCutOff ? 'disabled' : ''}
                >
                    ${dayMark ? `<span class="bb-day-num">${day}</span><span class="bb-day-mark">${dayMark}</span>` : day}
                </button>
            `;
        }

        html += `</div>`;
        container.innerHTML = html;
        updateCalendarSelection();
        bbRenderTimeNotes();
        bbRenderOutList();
    }

    window.renderCalendar();

    // ── Expose functions globally ──────────────────────────
    window.formatDate              = formatDate;
    window.updateTopBarTitle       = updateTopBarTitle;
    window.updateCalendarSelection = updateCalendarSelection;
    window.renderCalendar          = renderCalendar;
});

// ─── Calendar day click ──────────────────────────────────────────

window.bookingDates = { start: null, end: null };
window.bbCommittedDates = null;

function bbDayChosen() {
    /*  dev-build 198 — grey days explain, same as red, and are never selected. */
    if ($(this).hasClass('bo-grey')) {
        if (window.bbTakeSnapshot) window.bbTakeSnapshot();
        bbShowRedNote($(this).data('date'));
        return;
    }

    // Show cap note when clicking unavailable date
    if ($(this).hasClass('is-unavailable')) {
        (bbRedNoteDay = null, $('.bb-panel-content-cap-note')).removeClass('bb-note-red')
            .html(window.bookingBarConfig.barCapNote)
            .removeClass('hidden');
        return;
    }

    /*  dev-build 193 — a red day is explained, never selected. */
    if ($(this).hasClass('booked-out')) {
        if (window.bbTakeSnapshot) window.bbTakeSnapshot();
        bbShowRedNote($(this).data('date'));
        return;
    }

    // Stop if date cannot be selected
    if (
        $(this).hasClass('is-disabled') ||
        $(this).hasClass('is-closed')
    ) {
        return;
    }

    // Hide cap note by default
    $('.bb-panel-content-cap-note').addClass('hidden');

    const clickedDate = $(this).data('date');
    const { start, end } = window.bookingDates;

    if (start && end) {
        window.bookingDates.start = clickedDate;
        window.bookingDates.end   = null;
    } else if (!start) {
        window.bookingDates.start = clickedDate;
    } else {
        // ✅ Second click — check if same date
        if (clickedDate === start) {
            (bbRedNoteDay = null, $('.bb-panel-content-cap-note')).removeClass('bb-note-red')
                .html(window.bookingBarConfig.barSameDayNote)
                .removeClass('hidden');
            return;
        }

        if (clickedDate < start) {
            window.bookingDates.start = clickedDate;
            window.bookingDates.end   = null;
        } else {
            /*  The old "range crosses a fully booked day" refusal is gone (dev-build 193):
                every return day that would cross a blackout is already red, and red days
                never reach here. It also refused returning on a blackout's first morning,
                which the rule allows.                                                   */
            window.bookingDates.end = clickedDate;
        }
    }

    updateCalendarSelection();
    renderCalendar();
    /*  dev-build 196 — only re-reads if a cart write has not been read yet, or the
        last read is over a minute old. See bbRefreshIfStale in booking-bar.js. */
    if (typeof window.bbRefreshIfStale === 'function') window.bbRefreshIfStale();
}

/*  ── A CLICK THAT SURVIVES A REPAINT — dev-build 198 ─────────────────────────────
    Found by Ben's probe, 26-09-2026: el.click() on 21 Oct selected it, a real mouse
    did not. The calendar repaints by replacing its HTML; if that lands between press
    and release, the button pressed is gone, the browser fires no click on it, and
    the day silently does nothing. So a day is chosen by the DATE pressed and released
    on, not by the element. Mouse, pen and touch come through pointer events (a touch
    that scrolls is cancelled, so it never selects). Keyboard still uses click —
    detail is 0 for a keyboard click and 1+ for a pointer one, so nothing fires twice. */
var bbDownDate = null;
document.addEventListener('pointerdown', function (e) {
    const el = e.target && e.target.closest && e.target.closest('.bb-calendar-day');
    bbDownDate = el && !(e.pointerType === 'mouse' && e.button !== 0) ? el.getAttribute('data-date') : null;
}, true);
document.addEventListener('pointercancel', function () { bbDownDate = null; }, true);
document.addEventListener('pointerup', function (e) {
    const d = bbDownDate;
    bbDownDate = null;
    if (!d || !e.target || !e.target.closest || !e.target.closest('.booking-calendar')) return;
    const under = e.target.closest('.bb-calendar-day');
    if (under && under.getAttribute('data-date') !== d) return;
    const el = document.querySelector('.booking-calendar .bb-calendar-day[data-date="' + d + '"]');
    if (!el || el.disabled) return;
    bbDayChosen.call(el);
}, true);
$(document).on('click', '.bb-calendar-day', function (e) {
    if (e.originalEvent && e.originalEvent.detail === 0) bbDayChosen.call(this);
});